
import { Button } from "@/components/ui/button";

interface PortalHeaderProps {
  onLogout: () => void;
  debugInfo?: string;
}

const PortalHeader = ({ onLogout, debugInfo }: PortalHeaderProps) => {
  return (
    <>
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Investor Portal
          </h1>
          <p className="text-gray-600">
            Exclusive investment opportunities available for bidding
          </p>
        </div>
        <Button 
          onClick={onLogout}
          variant="outline"
          className="border-gray-300"
        >
          Logout
        </Button>
      </div>

      {debugInfo && (
        <div className="mb-4 p-3 bg-green-100 rounded-lg">
          <p className="text-sm text-green-800">Status: {debugInfo}</p>
        </div>
      )}
    </>
  );
};

export default PortalHeader;
